import React from 'react';
import PropTypes from 'prop-types';

class EghlForm extends React.Component {
  componentDidMount = () => {
    document.getElementById('eglForm').submit();
  };

  render() {
    const { eghlFormData } = this.props;
    return (
      <form
        name="frmPayment"
        method="post"
        action={eghlFormData.eGHL_api_url}
        id="eglForm"
        encType="application/x-www-form-urlencoded"
      >
        <input type="hidden" name="TransactionType" value={eghlFormData.TransactionType} />
        <input type="hidden" name="PymtMethod" value={eghlFormData.PymtMethod} />
        <input type="hidden" name="ServiceID" value={eghlFormData.ServiceID} />
        <input type="hidden" name="PaymentID" value={eghlFormData.PaymentID} />
        <input type="hidden" name="OrderNumber" value={eghlFormData.OrderNumber} />
        <input type="hidden" name="PaymentDesc" value={eghlFormData.PaymentDesc} />
        <input type="hidden" name="MerchantReturnURL" value={eghlFormData.MerchantReturnURL} />
        <input type="hidden" name="MerchantCallbackURL" value={eghlFormData.MerchantCallBackURL} />
        <input type="hidden" name="MerchantApprovalURL" value={eghlFormData.MerchantApprovalURL} />
        <input
          type="hidden"
          name="MerchantUnApprovalURL"
          value={eghlFormData.MerchantUnApprovalURL}
        />
        <input type="hidden" name="Amount" value={eghlFormData.Amount} />
        <input type="hidden" name="CurrencyCode" value={eghlFormData.CurrencyCode} />
        <input type="hidden" name="CustIP" value={eghlFormData.CustIP} />
        <input type="hidden" name="CustName" value={eghlFormData.CustName} />
        <input type="hidden" name="CustEmail" value={eghlFormData.CustEmail} />
        <input type="hidden" name="CustPhone" value={eghlFormData.CustPhone} />
        <input type="hidden" name="HashValue" value={eghlFormData.HashValue} />
        <input type="hidden" name="PageTimeout" value={eghlFormData.PageTimeout} />
      </form>
    );
  }
}

EghlForm.propTypes = {
  eghlFormData: PropTypes.object
};

export default EghlForm;
